(function () {
  if (customElements.get('theme-video-embed')) return;

  var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.loadPlayer();
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '200px 0px' }) : null;

  class ThemeVideoEmbed extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      if (observer) observer.observe(this);
      else Promise.resolve().then(() => this.loadPlayer());
    }

    disconnectedCallback() {
      if (observer) observer.unobserve(this);
    }

    loadPlayer() {
      if (!this.isConnected || this.shadowRoot) return;
      var template = this.querySelector('template');
      if (!template) return;
      // Shadow contents are not copied by cloneNode: carousel clones stay unloaded.
      var shadow = this.attachShadow({ mode: 'open' });
      shadow.appendChild(template.content.cloneNode(true));
    }
  }

  customElements.define('theme-video-embed', ThemeVideoEmbed);

  window.addEventListener('message', function (event) {
    var data = event.data;
    if (!data || data['x-tiktok-player'] !== true || data.type !== 'onPlayerReady') return;
    if (!event.source || typeof event.source.postMessage !== 'function') return;
    try {
      var hostname = new URL(event.origin).hostname;
      if (hostname !== 'tiktok.com' && !hostname.endsWith('.tiktok.com')) return;
      event.source.postMessage({ 'x-tiktok-player': true, type: 'unMute' }, event.origin);
    } catch (error) {}
  });
})();
